import React, { useCallback } from "react"

import { useAppSelector } from "../../../../hooks/use-app-selector.ts"
import { useDateFormat } from "../../../../hooks/use-date-format.ts"
import { selectProjectWritePermissions } from "../../../Project/helpers/project-permissions.selectors.ts"
import { ProjectViewFinanceList } from "../../../Project/ProjectViewPage/components/sections/ProjectViewFinance/ProjectViewFinance/ProjectViewFinanceList.tsx"
import {
  TOUR_DEMO_FINANCE_ITEMS,
  TOUR_DEMO_FINANCE_SUMMARY,
  TOUR_DEMO_PROJECT_ID
} from "../../content/tour-demo-data.ts"

/**
 * The REAL Project → Finance table (`ProjectViewFinanceList`, presentational,
 * confirmed with no internal `useSelector`/`connect`) fed the same
 * flattened financial-item data the Milestones demo seeds under each
 * milestone — so a payable created under "Cabinets" in the Milestones demo
 * shows up here under the exact same "Milestone" column a real project
 * uses, not a re-typed lookalike. See `DemoProjectMilestonesSection.tsx`.
 * `persistColumnConfig={false}` below keeps a demo column drag/resize/reset
 * local rather than overwriting every real project's saved Finance layout,
 * which is keyed by the same `"financial_transactions"` surface.
 */
export const DemoProjectFinanceSection = () => {
  const userId = useAppSelector((state) => state.auth.userInfo?.id ?? "demo-user")
  const projectPermissions = useAppSelector(selectProjectWritePermissions)
  const { userFormat } = useDateFormat()

  const items = TOUR_DEMO_FINANCE_ITEMS

  const onSelectRow = useCallback(() => {}, [])
  const noop = useCallback(() => {}, [])
  const noopAsync = useCallback(async () => {}, [])

  return (
    <div data-guide-target="project-finance-panel">
      <ProjectViewFinanceList
        persistColumnConfig={false}
        userId={userId}
        userDateFormat={userFormat ?? "MM/DD/YYYY"}
        projectPermissions={projectPermissions}
        projectId={TOUR_DEMO_PROJECT_ID}
        financialTransactionItems={items}
        financialSummary={TOUR_DEMO_FINANCE_SUMMARY}
        fetching={false}
        count={items.length}
        itemType={null}
        editableRow=""
        isAdding={false}
        options={{}}
        configOpen={false}
        generateInvoiceAllowed={false}
        onAddTransaction={noop}
        onOrderingChange={noop}
        onSelectRow={onSelectRow}
        onPageChange={noop}
        onLoadMore={noop}
        onCloseColumnConfig={noop}
        onRefresh={noopAsync}
      />
    </div>
  )
}
